import { createContext } from 'react';

import { remotes } from '../registry';

const RemotesContext = createContext({ remotes });

RemotesContext.displayName = 'RemotesContext';

export { RemotesContext };
